export default __webpack_public_path__ + "static/media/wora_logo.4ade1db3.png";